import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export const SalesLetter: React.FC = () => {
  const painPoints = ['Te quedaste mirando el celular esperando un mensaje que nunca llegó?', 'Sentiste que un hombre estaba súper interesado… y de repente cambió su energía?', 'Te prometiste “esta vez no me voy a enganchar tan rápido”… y terminaste pensando en él todo el día?', 'Intentaste actuar “fría” o “desinteresada” siguiendo consejos de TikTok… pero por dentro estabas explotando de ansiedad?', 'Sentiste que siempre terminas siendo “la que se enamora más”?'];
  const bsAdvice = ['Consejos vacíos como “solo deja de pensar tanto”', 'Gurús que te dicen que “actúes fría” y juegues juegos tóxicos', 'Videos motivacionales que te hacen sentir bien 10 minutos… pero no cambian nada', 'Consejos genéricos escritos por personas que jamás sintieron ansiedad emocional real', 'Métodos manipuladores que te hacen perder tu esencia femenina'];
  const solutions = ['Se cansaron de sobrepensar', 'Están agotadas de perseguir atención emocional', 'Quieren sentirse deseadas SIN rogar', 'Quieren dejar de sentirse reemplazables', 'Quieren cambiar la dinámica sin perder su feminidad'];
  return <section className="py-16 md:py-24 px-4 bg-brand-cream" data-id="element-182">
      <div className="max-w-3xl mx-auto text-lg md:text-xl leading-relaxed text-gray-800 space-y-8" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-184">
          <p className="font-serif italic text-brand-wine" data-id="element-185">
            Del Escritorio de...
          </p>
          <p className="font-bold" data-id="element-186">
            Re: Cómo dejar de perderte emocionalmente por hombres que no saben
            lo que quieren...
          </p>
          <p data-id="element-187">Querida mujer que está cansada de darle vueltas a todo...</p>
          <h2 className="text-2xl md:text-3xl font-serif font-bold mt-8 mb-4" data-id="element-188">
            ¿Alguna vez...
          </h2>

          <div className="space-y-4 bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-brand-blush" data-id="element-189">
            {painPoints.map((point, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-190">
                <XCircle className="w-6 h-6 text-red-600 shrink-0 mt-1" data-id="element-191" />
                <p className="text-gray-700" data-id="element-192">{point}</p>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="my-12" data-id="element-193">
          <p className="mb-6" data-id="element-194">
            Estos son exactamente los problemas que yo misma viví…
          </p>
          <p className="mb-12" data-id="element-195">
            …y son los mismos patrones emocionales que miles de mujeres siguen
            repitiendo hoy.
          </p>

          <blockquote className="border-l-4 border-brand-wine pl-6 py-2 my-12" data-id="element-196">
            <p className="font-serif text-2xl md:text-3xl italic text-brand-wine leading-snug" data-id="element-197">
              “Las relaciones NO deberían sentirse como una guerra mental
              constante.”
            </p>
          </blockquote>

          <p className="mb-6" data-id="element-198">
            Ahora, si quieres convertirte en esa mujer que transmite calma,
            misterio y seguridad…
          </p>
          <p className="mb-6" data-id="element-199">
            En lugar de pasar noches enteras sobreanalizando mensajes,
            stalkeando redes sociales o sintiéndote reemplazable…
          </p>
          <p className="mb-6" data-id="element-200">
            Y deseas sentirte emocionalmente poderosa SIN convertte en alguien
            fría o manipuladora…
          </p>
          <p className="font-bold" data-id="element-201">
            Entonces esta puede ser la carta más importante que leas este año.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal mt-16 mb-8" data-id="element-203">
            “Aquí Está El GRAN Problema…”
          </h2>
          <p data-id="element-204">
            Cuando empecé a buscar ayuda sobre relaciones y atracción femenina,
            descubrí algo:
          </p>
          <p className="font-bold" data-id="element-205">
            La mayoría de los consejos sobre “amor propio”, “feminidad” y
            “relaciones” son BASURA COMPLETA.
          </p>
          <p data-id="element-206">Y aquí está el por qué:</p>

          <div className="space-y-4 bg-brand-rose/50 p-6 md:p-8 rounded-2xl" data-id="element-207">
            {bsAdvice.map((point, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-208">
                <XCircle className="w-6 h-6 text-red-600 shrink-0 mt-1" data-id="element-209" />
                <p className="text-gray-700" data-id="element-210">{point}</p>
              </div>)}
          </div>

          <p className="mt-8" data-id="element-211">Y lo peor…</p>
          <p className="font-bold text-xl" data-id="element-212">
            Te hacen creer que el problema eres TÚ.
          </p>
          <p data-id="element-213">
            Como si fueras “demasiado intensa”. Como si sentir fuera un defecto.
            Como si necesitar claridad emocional fuera “desesperación”.
          </p>
          <p className="font-bold text-2xl text-brand-wine my-6" data-id="element-214">NO.</p>
          <p data-id="element-215">El problema no es que sientas mucho.</p>
          <p className="font-bold" data-id="element-216">
            El problema es que nadie te enseñó cómo mantener tu valor emocional
            mientras te involucras con un hombre.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6 mt-16" data-id="element-217">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal mb-8" data-id="element-218">
            Así Que Decidí Resolver Todo Eso...
          </h2>
          <p data-id="element-219">
            Después de años observando patrones emocionales, dinámicas
            masculinas y errores que destruyen la atracción SIN que la mujer se
            dé cuenta…
          </p>
          <p data-id="element-220">Creé una guía completamente diferente.</p>
          <p className="font-bold mb-6" data-id="element-221">
            Una guía diseñada específicamente para mujeres que:
          </p>

          <div className="space-y-4 bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-emerald-100" data-id="element-222">
            {solutions.map((point, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-223">
                <CheckCircle2 className="w-6 h-6 text-emerald-600 shrink-0 mt-1" data-id="element-224" />
                <p className="text-gray-700" data-id="element-225">{point}</p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
};